import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState, FULL_MODAL_ACTIONS, NO_SCROLL } from 'src/app';

/**
 * To render custom content send it as ng-content by wrapping
 * it inside the component tags:
 *
 * ```html
 * <app-full-modal>
 *   <div class="my-custom-component--modal-content">
 *   </div>
 * </app-full-modal>
 * ```
 */
@Component({
  selector: 'app-full-modal',
  templateUrl: './full-modal.component.html',
  styleUrls: ['./full-modal.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FullModalComponent implements OnInit, OnDestroy {
  // TODO (Chore): Can we remove action? It's not used anywhere
  @Input() public action?: FULL_MODAL_ACTIONS;

  @Input() public parentPosition?: { x: number; y: number };

  @Input() public title?: string;
  @Input() public subtitle?: string;
  @Input() public description?: string;

  @Input() public hideActionButtons = false;
  @Input() public confirmationButtonText = 'Sí, cancelar';
  @Input() public cancelButtonText = 'Regresar';

  @Output() private onConfirmationAction = new EventEmitter<void>();
  @Output() private onCloseModal = new EventEmitter<void>();

  constructor(private readonly store: Store<AppState>) {}

  ngOnInit() {
    window.scrollTo(300, 0);
    this.noScroll(true);
  }

  ngOnDestroy() {
    this.noScroll(false);
  }

  public handleConfirm() {
    this.onConfirmationAction.next();
  }

  public handleClose() {
    if (this.parentPosition) {
      window.scrollTo(this.parentPosition.x, this.parentPosition.y);
    } else {
      window.scrollTo(300, 600);
    }
    this.onCloseModal.next();
  }

  private noScroll(block: boolean) {
    this.store.dispatch({
      type: NO_SCROLL,
      payload: { block, source: 'FullModalComponent' },
    });
  }
}
